var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { put, call, select } from 'redux-saga/effects';
import ModelKeyRepository from '../repositories/ImmutableRepository';
import KeyModifier from '../repositories/modifier/ExpandKeyModifier';
import * as RepositoryState from '../constants/RepositoryState';
import { fetchInitialLive, fetchLiveUpdate, fetchUpdateBetslips, fetchInitialMatch, fetchUpdateMatch, fetchPopularLive, fetchUserBalance, fetchInitialTimetable, fetchTimetableUpdate, fetchBetStatus, fetchFreebet } from './api';
import { sagaActions } from './actions';
import { selectForLive, selectForLiveMatch, selectUser, selectForLiveBetslips, selectForTimetable, selectForBets, selectForMultiBets, selectForQuickBets, selectForPopularLive } from './selectors';
var live_initial = sagaActions.live_initial, live_update = sagaActions.live_update, live_update_betslips = sagaActions.live_update_betslips, live_initial_match = sagaActions.live_initial_match, live_update_match = sagaActions.live_update_match, get_popular_live = sagaActions.get_popular_live, get_balance = sagaActions.get_balance, timetable_initial = sagaActions.timetable_initial, timetable_update = sagaActions.timetable_update, get_bet_status = sagaActions.get_bet_status, get_multi_bet_status = sagaActions.get_multi_bet_status, get_quickbet_status = sagaActions.get_quickbet_status, get_freebet = sagaActions.get_freebet;
var liveRepository = new ModelKeyRepository();
var timetableRepository = new ModelKeyRepository();
var delay = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
function transformData(data, section) {
    var repo;
    switch (section) {
        case 'live':
        case 'liveMatch':
            repo = liveRepository;
            break;
        case 'timetable':
            repo = timetableRepository;
            break;
    }
    if (!repo) {
        return data;
    }
    var modifier = new KeyModifier(repo);
    if (modifier) {
        modifier.modify(data);
    }
    return data;
}
function fetchActionWithTransform(action, apiFn, section, requestData) {
    var _a, version, content, expired, error, transformed, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, put(action.request(__assign({}, requestData)))];
            case 1:
                _b.sent();
                return [4 /*yield*/, call(apiFn, requestData)];
            case 2:
                _a = _b.sent(), version = _a.version, content = _a.content, expired = _a.expired, error = _a.error;
                if (!content) return [3 /*break*/, 4];
                transformed = transformData(content, section);
                data = __assign({ expired: expired, version: version }, transformed);
                return [4 /*yield*/, put(action.success(data))];
            case 3:
                _b.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, put(action.failure(requestData, error))];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
function fetchAction(action, apiFn, requestData) {
    var response, _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, put(action.request(requestData))];
            case 1:
                _d.sent();
                return [4 /*yield*/, call(apiFn, requestData)];
            case 2:
                response = _d.sent();
                if (!(response !== undefined)) return [3 /*break*/, 4];
                return [4 /*yield*/, put(action.success(response))];
            case 3:
                _d.sent();
                return [3 /*break*/, 7];
            case 4:
                _a = put;
                _c = (_b = action).failure;
                return [4 /*yield*/, call(apiFn, requestData)];
            case 5: return [4 /*yield*/, _a.apply(void 0, [_c.apply(_b, [_d.sent()])])];
            case 6:
                _d.sent();
                _d.label = 7;
            case 7: return [2 /*return*/];
        }
    });
}
var fetchInitialLiveSaga = fetchActionWithTransform.bind(null, live_initial, fetchInitialLive, 'live');
var fetchLiveUpdateSaga = fetchActionWithTransform.bind(null, live_update, fetchLiveUpdate, 'live');
var fetchUpdateBetslipsSaga = fetchAction.bind(null, live_update_betslips, fetchUpdateBetslips);
var fetchInitialMatchSaga = fetchActionWithTransform.bind(null, live_initial_match, fetchInitialMatch, 'liveMatch');
var fetchUpdateMatchSaga = fetchActionWithTransform.bind(null, live_update_match, fetchUpdateMatch, 'liveMatch');
var fetchBalanceSaga = fetchAction.bind(null, get_balance, fetchUserBalance);
var fetchPopularLiveSaga = fetchAction.bind(null, get_popular_live, fetchPopularLive);
var fetchInitialTimetableSaga = fetchActionWithTransform.bind(null, timetable_initial, fetchInitialTimetable, 'timetable');
var fetchTimetableUpdateSaga = fetchActionWithTransform.bind(null, timetable_update, fetchTimetableUpdate, 'timetable');
var fetchBetsStatusSaga = fetchAction.bind(null, get_bet_status, fetchBetStatus);
var fetchMultiBetsStatusSaga = fetchAction.bind(null, get_multi_bet_status, fetchBetStatus);
var fetchQuickBetsStatusSaga = fetchAction.bind(null, get_quickbet_status, fetchBetStatus);
var fetchFreebetSaga = fetchAction.bind(null, get_freebet, fetchFreebet);
export function loadInitialLive() {
    var requestData, requestDataPop, eligible;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, select(selectForLive)];
            case 1:
                requestData = _a.sent();
                return [4 /*yield*/, select(selectForPopularLive)];
            case 2:
                requestDataPop = _a.sent();
                eligible = requestData.repoState === RepositoryState.NOT_INITED && (window.location.pathname.includes('/live') || window.location.pathname === '/' || window.location.pathname.includes('/timetable'));
                if (!eligible) return [3 /*break*/, 5];
                return [4 /*yield*/, call(fetchInitialLiveSaga, requestData)];
            case 3:
                _a.sent();
                return [4 /*yield*/, call(fetchPopularLiveSaga, requestDataPop)];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [4 /*yield*/, call(delay, 2000)];
            case 6:
                _a.sent();
                return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
}
export function loadLiveUpdate() {
    var requestData, repoState, path, tab, pathname, _a, activeRoute, _b, matchId, eligible;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, select(selectForLive)];
            case 1:
                requestData = _c.sent();
                repoState = requestData.repoState;
                path = requestData.path;
                tab = requestData.tab;
                pathname = window.location.pathname;
                _a = pathname.split('/'), activeRoute = _a[1], _b = _a[2], matchId = _b === void 0 ? '' : _b;
                if (matchId && activeRoute === 'live') {
                    requestData.matchId = matchId;
                }
                eligible = (repoState === RepositoryState.INITED || repoState === RepositoryState.UPDATING)
                    && (path === '/live' || tab === 'live') && !(matchId && activeRoute === 'live');
                if (!eligible) return [3 /*break*/, 3];
                return [4 /*yield*/, call(fetchLiveUpdateSaga, requestData)];
            case 2:
                _c.sent();
                _c.label = 3;
            case 3: return [4 /*yield*/, call(delay, 2000)];
            case 4:
                _c.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
}
function isObjectEmpty(obj) {
    if (obj === void 0) { obj = {}; }
    return Object.keys(obj).length === 0;
}
export function loadUpdateBetslips() {
    var requestData, eligible;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, select(selectForLiveBetslips)];
            case 1:
                requestData = _a.sent();
                eligible = !isObjectEmpty(requestData.basket);
                if (!eligible) return [3 /*break*/, 3];
                return [4 /*yield*/, call(fetchUpdateBetslipsSaga, requestData)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [4 /*yield*/, call(delay, 1500)];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
}
export function loadInitialMatch() {
    var requestData, pathname, _a, activeRoute, _b, matchId, eligible;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, select(selectForLiveMatch)];
            case 1:
                requestData = _c.sent();
                pathname = window.location.pathname;
                _a = pathname.split('/'), activeRoute = _a[1], _b = _a[2], matchId = _b === void 0 ? '' : _b;
                if (matchId && activeRoute === 'live') {
                    requestData.matchId = matchId;
                }
                eligible = requestData.repoState === RepositoryState.NOT_INITED && (pathname.includes('/live') || pathname === '/' || pathname.includes('/timetable')) && (matchId && activeRoute === 'live');
                if (!eligible) return [3 /*break*/, 3];
                return [4 /*yield*/, call(fetchInitialMatchSaga, requestData)];
            case 2:
                _c.sent();
                _c.label = 3;
            case 3: return [4 /*yield*/, call(delay, 2000)];
            case 4:
                _c.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
}
export function loadUpdateMatch() {
    var requestData, repoState, path, tab, pathname, _a, activeRoute, _b, matchId, eligible;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, select(selectForLiveMatch)];
            case 1:
                requestData = _c.sent();
                repoState = requestData.repoState;
                path = requestData.path;
                tab = requestData.tab;
                pathname = window.location.pathname;
                _a = pathname.split('/'), activeRoute = _a[1], _b = _a[2], matchId = _b === void 0 ? '' : _b;
                if (matchId && activeRoute === 'live') {
                    requestData.matchId = matchId;
                }
                eligible = (repoState === RepositoryState.INITED || repoState === RepositoryState.UPDATING)
                    && (path === '/live' || tab === 'live') && (matchId && activeRoute === 'live');
                if (!eligible) return [3 /*break*/, 3];
                return [4 /*yield*/, call(fetchUpdateMatchSaga, requestData)];
            case 2:
                _c.sent();
                _c.label = 3;
            case 3: return [4 /*yield*/, call(delay, 2000)];
            case 4:
                _c.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
}
export function loadPopularLive() {
    var requestData, path;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, select(selectForPopularLive)];
            case 1:
                requestData = _a.sent();
                path = requestData.path;
                if (!(path === '/')) return [3 /*break*/, 4];
                return [4 /*yield*/, call(fetchPopularLiveSaga, requestData)];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(delay, 10000)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [4 /*yield*/, call(delay, 2000)];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
}
export function loadBalance() {
    var selectData, user, isAuthenticated, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, select(selectUser)];
            case 1:
                selectData = _a.sent();
                user = selectData.user;
                isAuthenticated = Object.keys(user).length > 0 && user.constructor === Object;
                if (!isAuthenticated) return [3 /*break*/, 4];
                data = { accountId: user.accountId };
                return [4 /*yield*/, call(fetchBalanceSaga, data)];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(delay, 10000)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [4 /*yield*/, call(delay, 1000)];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
}
export function loadInitialTimetable() {
    var requestData, path, eligible;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, select(selectForTimetable)];
            case 1:
                requestData = _a.sent();
                path = requestData.path;
                eligible = requestData.repoState === RepositoryState.NOT_INITED &&
                    (path === '/timetable');
                if (!eligible) return [3 /*break*/, 3];
                return [4 /*yield*/, call(fetchInitialTimetableSaga, requestData)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [4 /*yield*/, call(delay, 3000)];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
}
export function loadTimetableUpdate() {
    var requestData, repoState, path, eligible;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, select(selectForTimetable)];
            case 1:
                requestData = _a.sent();
                repoState = requestData.repoState;
                path = requestData.path;
                eligible = (repoState === RepositoryState.INITED || repoState === RepositoryState.UPDATING) &&
                    (path === '/timetable');
                if (!eligible) return [3 /*break*/, 4];
                return [4 /*yield*/, call(fetchTimetableUpdateSaga, requestData)];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(delay, 30000)];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, call(delay, 3000)];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
}
export function loadBetsStatus() {
    var requestData, languageId, bets;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, select(selectForBets)];
            case 1:
                requestData = _a.sent();
                languageId = requestData.languageId, bets = requestData.bets;
                if (!(bets.length > 0)) return [3 /*break*/, 4];
                return [4 /*yield*/, call(fetchBetsStatusSaga, { stakeId: bets[0].stakeId, languageId: languageId })];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(delay, 1000)];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, call(delay, 1500)];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
}
export function loadMultiBetsStatus() {
    var requestData, languageId, bets;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, select(selectForMultiBets)];
            case 1:
                requestData = _a.sent();
                languageId = requestData.languageId, bets = requestData.bets;
                if (!(bets.length > 0)) return [3 /*break*/, 4];
                return [4 /*yield*/, call(fetchMultiBetsStatusSaga, { stakeId: bets[0].stakeId, languageId: languageId })];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(delay, 1000)];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, call(delay, 1500)];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
}
export function loadQuickBetsStatus() {
    var requestData, languageId, bets;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, select(selectForQuickBets)];
            case 1:
                requestData = _a.sent();
                languageId = requestData.languageId, bets = requestData.bets;
                if (!(bets.length > 0)) return [3 /*break*/, 4];
                return [4 /*yield*/, call(fetchQuickBetsStatusSaga, { stakeId: bets[0].stakeId, languageId: languageId })];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(delay, 1000)];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, call(delay, 1500)];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
}
export function loadFreebet() {
    var selectData, user, isAuthenticated;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, select(selectUser)];
            case 1:
                selectData = _a.sent();
                user = selectData.user;
                isAuthenticated = Object.keys(user).length > 0 && user.constructor === Object;
                if (!(isAuthenticated && user.gamblerId !== undefined)) return [3 /*break*/, 4];
                return [4 /*yield*/, call(fetchFreebetSaga)];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(delay, 5 * 60 * 1000)];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, call(delay, 1000)];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
}



// WEBPACK FOOTER //
// ./src/sagas/index.js